import apiClient from '../common/apiClient';
import { makePostRequestSettings } from '../common/utils';
import { makeMonitoredObjectsUrl } from '../monitored';

export type TDeviceCommandType =
    | 'FUEL_DISTRIBUTION'
    | 'TUNNEL_CONNECTION'
    | 'LIVE_VIEW';

export interface IDeviceCommand<T> {
    '@type': TDeviceCommandType;
    parameters: T;
}

export const restPostDeviceCommand = <T>(
    data: IDeviceCommand<T>,
    id: string
): Promise<null> =>
    apiClient.send(
        makePostRequestSettings(
            makeMonitoredObjectsUrl(`/objects/${id}/device-commands`),
            data
        )
    );
